import { NgModule } from '@angular/core';

import { HomeComponent } from './home.component';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { Section01Module } from './components/section01/section01.module';
import { Section02Module } from './components/section02/section02.module';
import { Section03Module } from './components/section03/section03.module';
import { Section04Module } from './components/section04/section04.module';
import { Section05Module } from './components/section05/section05.module';
import { Section06Module } from './components/section06/section06.module';
import { Section07Module } from './components/section07/section07.module';
import { Section08Module } from './components/section08/section08.module';

@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule,

    Section01Module,
    Section02Module,
    Section03Module,    
    Section04Module,
    Section05Module,
    Section06Module,
    Section07Module,
    Section08Module
  ],
  exports: [
    HomeComponent
  ]
})

export class HomeModule { }
